import styled from "styled-components";
import { SPACING } from "../../../utils/constants";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const ChartTitle = styled.h3`
  color: var(--color-text-default);
  font-family: "Crimson Pro", sans-serif;
  margin: 0 0 ${SPACING.md}px 0;
`;

export const EmptyStateWrapper = styled.div`
  text-align: center;
  padding: ${SPACING.xl}px;
`;

export const EmptyStateMessage = styled.p`
  color: var(--color-text-default);
  font-family: "Crimson Pro", sans-serif;
`;
